import React from 'react'
import { Route, Switch } from 'react-router'
import Guest from '../components/Guest'
import Header from '../components/Header'
import Login from '../components/Login'
import ScreenChanger from '../components/ScreenChanger'

export default function GuestOrLogin() {
  return (
    <div>
      <Header />
      <ScreenChanger />

      <Switch>
        <Route exact path={`/`}>
          <Guest />
        </Route>
        <Route path={`/login`} component={Login} />
      </Switch>
    </div>
  )
}
